"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Svg = __importStar(require("react-native-svg"));
exports.default = (props) => (React.createElement(Svg.Svg, Object.assign({}, props, { viewBox: '0 0 24 24' }),
    React.createElement(Svg.G, { "data-name": 'Layer 2' },
        React.createElement(Svg.G, { "data-name": 'menu-2' },
            React.createElement(Svg.Rect, { width: '24', height: '24', transform: 'rotate(180 12 12)', opacity: '0' }),
            React.createElement(Svg.Circle, { cx: '4', cy: '12', r: '1' }),
            React.createElement(Svg.Rect, { x: '7', y: '11', width: '14', height: '2', rx: '.94', ry: '.94' }),
            React.createElement(Svg.Rect, { x: '3', y: '16', width: '18', height: '2', rx: '.94', ry: '.94' }),
            React.createElement(Svg.Rect, { x: '3', y: '6', width: '18', height: '2', rx: '.94', ry: '.94' })))));
//# sourceMappingURL=Menu_2.js.map